import { useMutation } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { downloadInvoicePdf, downloadInvoicesZip } from '../invoices.api';

function triggerBlobDownload(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  // Delay revoke to allow the download to start (same pattern as value.api PDF downloads).
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

/** Maps a gated/forbidden/not-found response to a stable i18n key for the toast. */
export function invoiceDownloadErrorKey(error: unknown): string {
  const status = (error as AxiosError)?.response?.status;
  if (status === 503) return 'invoices.errors.pdfUnavailable';
  if (status === 403) return 'invoices.errors.downloadForbidden';
  if (status === 404) return 'invoices.errors.notFound';
  return 'errors.generic';
}

export function useDownloadInvoicePdf() {
  return useMutation({
    mutationFn: (invoiceId: string) => downloadInvoicePdf(invoiceId),
    onSuccess: (blob, invoiceId) => triggerBlobDownload(blob, `factuur-${invoiceId}.pdf`),
  });
}

export function useDownloadInvoicesZip() {
  return useMutation({
    mutationFn: (invoiceIds: string[]) => downloadInvoicesZip(invoiceIds),
    onSuccess: (blob) => triggerBlobDownload(blob, 'facturen.zip'),
  });
}
